var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesktopPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300px",
    height: "300px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.952
    },
    fill: "#fe3398",
    d: "M 26.5,4.5 C 107.167,4.33334 187.834,4.5 268.5,5C 280.559,8.05856 288.392,15.5586 292,27.5C 292.667,87.8333 292.667,148.167 292,208.5C 288.825,219.675 281.658,226.842 270.5,230C 247.536,231.27 224.536,231.936 201.5,232C 213,248.167 224.5,264.333 236,280.5C 238.136,283.993 237.969,287.326 235.5,290.5C 177.207,291.662 118.874,291.829 60.5,291C 56.6833,287.385 56.5167,283.552 60,279.5C 71.6224,263.755 83.1224,247.922 94.5,232C 71.1307,231.937 47.7974,231.271 24.5,230C 12.5917,226.03 5.42508,217.863 3,205.5C 2.33333,147.167 2.33333,88.8333 3,30.5C 5.45327,16.8838 13.2866,8.21718 26.5,4.5 Z M 29.5,16.5 C 108.167,16.3333 186.834,16.5 265.5,17C 273.22,18.3858 278.053,22.8858 280,30.5C 280.667,88.8333 280.667,147.167 280,205.5C 277.083,213.747 271.25,218.247 262.5,219C 186.167,219.667 109.833,219.667 33.5,219C 22.9013,218.398 16.7346,212.898 15,202.5C 14.3333,146.167 14.3333,89.8333 15,33.5C 16.4583,24.8803 21.2916,19.2137 29.5,16.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopPink);
export default __webpack_public_path__ + "static/media/Desktop_pink.4a418096c65dbef8db5138cf4c56c65d.svg";
export { ForwardRef as ReactComponent };